import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FunctionForm.css";

const FunctionForm = () => {
  const [formData, setFormData] = useState({

    images: null, // Changed from string to null for file handling
    category: "",
    subcategory: "",
   
  });

  const [categories, setCategories] = useState([]);
  const [catagory, setcatagory] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [imagePreview, setImagePreview] = useState(""); // For showing preview of selected image

  
  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    fetchCategories();
    fetchcatagory();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_URL}/categories`);
      const vendorSubcategories = res.data
        .filter(cat => cat.category === "Vendors")
        .flatMap(cat => Array.isArray(cat.subcategory) ? cat.subcategory : []);
      
      const normalized = res.data.map(cat => ({
        ...cat,
        subcategory: Array.isArray(cat.subcategory)
          ? cat.subcategory
          : cat.subcategory
          ? [cat.subcategory]
          : [],
        services: vendorSubcategories,
      }));
      
      setCategories(normalized);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchcatagory = async () => {
    try {
      const res = await axios.get(`${API_URL}/catagory`);
      setcatagory(res.data);
    } catch (err) {
      console.error("Error fetching catagory:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

// Handle single image change
const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setImagePreview(URL.createObjectURL(file));
    setFormData(prev => ({ ...prev, images: file }));
  } else {
    setImagePreview("");
    setFormData(prev => ({ ...prev, images: null }));
  }
};

const handleEdit = (collection) => {
  setFormData({
    ...collection,
    images: [], // Reset file input (user will re-upload new images)
   subcategory: Array.isArray(collection.subcategory)
      ? collection.subcategory[0] || ""
      : collection.subcategory || "",
    services: Array.isArray(collection.services)
      ? collection.services
      : collection.services
      ? [collection.services]
      : [],
    openServices: false,
  });
  
  // Set image previews for existing images
  if (collection.images && collection.images.length > 0) {
    setImagePreview(collection.images.map(img => `${API_URL}/${img}`));
  } else {
    setImagePreview([]);
  }
  
  setEditingId(collection._id);
};

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      category: value,
      subcategory: "",
      services: [],
    }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await axios.delete(`${API_URL}/catagory/${id}`);
      setcatagory((prev) => prev.filter((item) => item._id !== id));
    } catch (err) {
      console.error("Error deleting category:", err);
      alert("Failed to delete. Please try again.");
    }
  };

 // Handle form submit
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const formDataToSend = new FormData();

    // Append single image
    if (formData.images) {
      formDataToSend.append("images", formData.images);
    }

    // Append other form fields
    Object.keys(formData).forEach(key => {
      if (key !== "images" && key !== "openServices") {
        formDataToSend.append(key, formData[key]);
      }
    });

    if (editingId) {
      await axios.put(`${API_URL}/catagory/${editingId}`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setMessage("Function updated successfully!");
    } else {
      await axios.post(`${API_URL}/catagory`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setMessage("Function added successfully!");
    }

    setError(false);
    resetForm();
    fetchcatagory();
  } catch (err) {
    setMessage("Error saving collection: " + (err.response?.data?.error || err.message));
    setError(true);
  }
};
  const resetForm = () => {
    setFormData({
   
      images: null,
      category: "",
      subcategory: "",
    
    });
    setEditingId(null);
    setImagePreview("");
  };



  const handleView = (collection) => {
    setSelectedCollection(collection);
  };

  return (
    <div className="category-form-container">
      <h2>{editingId ? "Edit Collection" : "Add New Function Collection"}</h2>

      {message && (
        <p className={`Function-form-message ${error ? "error" : "success"}`}>
          {message}
        </p>
      )}

      {/* Image Upload */}
<div className="image-upload-section">
  <label>Image:</label>
  <input 
    type="file" 
    accept="image/*" 
    onChange={handleImageChange}
  />
  {imagePreview && (
    <div className="image-preview">
      <img 
        src={imagePreview} 
        alt="Preview" 
        style={{
          maxWidth: '200px', 
          maxHeight: '200px', 
          marginTop: '10px', 
          borderRadius: '10px'
        }}
      />
    </div>
  )}
</div>


      {/* Category Dropdown */}
      <div className="category-dropdown">
        <label>Choose Category:</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleCategoryChange}
        >
          <option value="">-- Select Category --</option>
          {categories.map((cat) => (
            <option key={cat._id} value={cat.category}>
              {cat.category}
            </option>
          ))}
        </select>
      </div>

      {/* Subcategory Dropdown */}
      {formData.category && (
        <div className="subcategory-dropdown">
          <label>Choose Subcategory:</label>
          <select
            name="subcategory"
            value={formData.subcategory}
            onChange={handleChange}
          >
            <option value="">-- Select Subcategory --</option>
            {categories
              .find((cat) => cat.category === formData.category)
              ?.subcategory.map((sub, idx) => (
                <option key={idx} value={sub}>
                  {sub}
                </option>
              ))}
          </select>
        </div>
      )}

  

      {/* Form */}
      <form onSubmit={handleSubmit} className="category-form">
       
        <button type="submit">
          {editingId ? "Update Collection" : "Add Collection"}
        </button>
      </form>

      {/* View Section */}
      {selectedCollection && (
        <div className="view-details">
          <h3>Collection Details</h3>
          {selectedCollection.image && (
            <div className="collection-image">
              <img 
                src={`${API_URL}/${selectedCollection.image}`} 
                alt={selectedCollection.name}
                style={{ maxWidth: '200px', maxHeight: '200px' }}
              />
            </div>
          )}
         
          <p>
            <strong>Category:</strong> {selectedCollection.category}
          </p>
          <p>
            <strong>Subcategory:</strong> {selectedCollection.subcategory}
          </p>
         
        </div>
      )}

      {/* Table */}
      <h3>All catagory</h3>
      <table className="category-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Category</th>
            <th>Subcategory</th>
            
          </tr>
        </thead>
        <tbody>
          {catagory.map((col) => (
            <tr key={col._id}>
             <td>
  {col.images && col.images.length > 0 ? (
    <div style={{ display: "flex", gap: "5px" }}>
      {col.images.map((img, idx) => (
        <img
          key={idx}
          src={`${API_URL}/${img}`}
          alt={`Image ${idx}`}
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ))}
    </div>
  ) : (
    <span>No image</span>
  )}
</td>

              <td>{col.category}</td>
              <td>{col.subcategory}</td>
             
              <td>
                <button onClick={() => handleView(col)}>View</button>
                <button onClick={() => handleEdit(col)}>Edit</button>
                <button onClick={() => handleDelete(col._id)}>Delete</button>
              </td>
            </tr>
          ))}
          {catagory.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No catagory found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FunctionForm;
